import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import { ORGANIZATION_AI_MODELS_KEY } from "../../managers/ia/queries";
import type { OrganizationAiModelsResponse } from "../../managers/ia/types/aiModel.api";
import { useSessionQuery, type LiveState } from "../session/useSessionQuery";

/** Catalogue des modèles d'IA de l'organisation et modèle sélectionné. */
export function useOrganizationAiModels(): LiveState<OrganizationAiModelsResponse> {
    return useSessionQuery(ORGANIZATION_AI_MODELS_KEY, (sdk) =>
        sdk.iaManager.getOrganizationAiModel(),
    );
}

export type AiModels = {
    getOrganizationAiModel: () => Promise<OrganizationAiModelsResponse>;
    /** La réponse remplace `useOrganizationAiModels`. */
    assignOrganizationAiModel: (
        modelId: string,
    ) => Promise<OrganizationAiModelsResponse>;
};

/** Modèle d'IA de l'organisation. */
export function useAiModels(): AiModels {
    const { iaManager, queryClient } = useSdk();

    return useMemo<AiModels>(
        () => ({
            getOrganizationAiModel: () => iaManager.getOrganizationAiModel(),
            assignOrganizationAiModel: async (modelId) => {
                const models =
                    await iaManager.assignOrganizationAiModel(modelId);
                queryClient.setQueryData(ORGANIZATION_AI_MODELS_KEY, models);
                return models;
            },
        }),
        [iaManager, queryClient],
    );
}
